import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2384d700"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "empty__content !tw-pb-0 !tw-box-border !tw-h-auto"
}
const _hoisted_2 = { class: "empty__banner tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4" }
const _hoisted_3 = { class: "empty__banner__img md:!tw-w-[50%]" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "empty__banner__content"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode(" You don't have any"),
  /*#__PURE__*/_createElementVNode("br", { class: "tw-hidden md:!tw-flex" }),
  /*#__PURE__*/_createTextVNode(" jobs yet! ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Start exploring new opportunities and find the perfect job to match your skills and schedule. ", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "empty__banner__content"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Don't have any jobs yet!", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "All job listings will be displayed here.", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "empty__banner__footer tw-w-full" }
const _hoisted_14 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full tw-h-[calc(100dvh-221px)]"
}
const _hoisted_15 = {
  key: 2,
  class: "tw-flex flex-row tw-gap-5 tw-flex-wrap"
}

import { UserRolesEnum } from "@/core/enums/RolesEnum";
import { JOBS_ROUTE } from "@/modules/jobs/routes";
import { USER_STORE } from "@/store/modules/user";
import { WORKSTATION } from "@/store/modules/workstation";
import JobCard from "@/modules/jobs/components/JobCard.vue";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import debounce from "lodash/debounce";
import Loader from "@/core/components/common/Loader.vue";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import { JOBS_STORE } from "@/store/modules/jobs";

import { JOB_DETAILS_ROUTE } from "@/modules/jobs/routes";
import { JobsState } from "@/core/models/jobs";


export default /*#__PURE__*/_defineComponent({
  __name: 'TradePassportJobs',
  setup(__props) {

const store = useStore();
const router = useRouter();
const getUserWorkStationFieldAccess = computed(
  () => store.getters[`${WORKSTATION}/getUserWorkStationFieldAccess`]
);
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const loading = ref(false);
const toggledView = ref("tile");
const selectedJob = ref("");

const getIsOpenTradePassportasViewMode = computed(
  () => store.getters[`${TRADE_ESTIMATE_STORE}/isOpenTradePassportasViewMode`]
);
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const setSelectedJob = async (value: string) => {
  store.commit(`${JOBS_STORE}/setJobDetails`, {});
  router.push({ name: JOB_DETAILS_ROUTE, params: { refId: value } });
  selectedJob.value = value;
};

const jobsState = computed<JobsState["jobs"]>(() => {
  const result = store.getters[`${JOBS_STORE}/getCompletedJobs`]
    .map((job: any) => ({
      ...job,
      properties: job.projectProperties
        ?.filter((projProperty: any) => projProperty.property)
        ?.map((projProperty: any) => projProperty.property),
    }))
    .filter((property: any) => property);
  console.log("result ", result);
  return result;
});

const isUserProprtyOwner = computed(
  () =>
    user.value?.role?.name === UserRolesEnum.PROPERTY_OWNER ||
    getIsOpenTradePassportasViewMode.value
);
const contractorTradePassportWorkstationId = computed(
  () =>
    store.getters[
      `${TRADE_ESTIMATE_STORE}/getContractorTradePassportWorkstationId`
    ]
);
const onClickFindJobs = () => {
  router.push({ name: JOBS_ROUTE });
};

const onClickToggleView = (value: string) => {
  toggledView.value = value;
};

onMounted(async () => {
  loading.value = true;
  try {
    if (isUserProprtyOwner.value) {
      await store.dispatch(`${JOBS_STORE}/fetchCompletedJobs`, {
        workStationId: contractorTradePassportWorkstationId.value,
      });
    } else {
      await store.dispatch(`${JOBS_STORE}/fetchCompletedJobs`, {
        workStationId: activeUserWorkstation.value.id,
      });
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-w-full md:tw-absolute md:tw-z-[999] md:tw-bottom-[60px] md:tw-w-full md:tw-max-w-full md:tw-h-auto md:tw-overflow-y-hidden md:tw-overflow-x-auto md:tw-flex md:tw-items-end working-1 tw-max-h-[620px] tw-overflow-auto no-scrollbar md:tw-justify-center", {
      'md:!tw-pr-8 md:!tw-h-full md:!tw-justify-center md:!tw-items-center md:!tw-bottom-0 md:!tw-top-16 md:!tw-z-[1] rmd:!tw-flex rmd:!tw-items-center rmd:!tw-justify-center rmd:!tw-h-[calc(100dvh-11rem)] rmd:!tw-max-h-[unset]':
        !loading.value && !jobsState.value.length,
    }])
  }, [
    (!loading.value && !jobsState.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: require('../../../assets/images/jobs-empty.png'),
                alt: "",
                class: "tw-w-full"
              }, null, 8, _hoisted_4)
            ]),
            (!isUserProprtyOwner.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12)),
            _createElementVNode("div", _hoisted_13, [
              (getUserWorkStationFieldAccess.value && !isUserProprtyOwner.value)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: onClickFindJobs,
                    class: "button button-purple",
                    width: "100%"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Find Jobs")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(Loader, { show: loading.value }, null, 8, ["show"])
        ]))
      : _createCommentVNode("", true),
    (jobsState.value.length && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobsState.value, (job) => {
            return (_openBlock(), _createBlock(JobCard, {
              key: job.refId,
              onOnSelect: setSelectedJob,
              value: job.refId,
              job: job,
              jobType: "active",
              hasProgressBar: true,
              class: _normalizeClass(`${
          selectedJob.value === job.refId ? 'tw-shadow-[0_0_0_4px_#FAA100_inset]' : ''
        }`)
            }, null, 8, ["value", "job", "class"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})